import { handleClickColor } from "../../Common/Util";

export function CurrentRulingPeriod (props) {
  const clientData=props.clientData;

  return(
    <table class="m-0 p-0 table table-bordered table-hover caption-top text-center">
      <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Current Ruling Period</h4></caption>
      <thead class="m-0 p-0">
        <tr class="m-0 p-0">
          <th class="m-0 p-1"></th> 
          <th class="m-0 p-1">Dasha</th> 
          <th class="m-0 p-1">Bhukti</th> 
          <th class="m-0 p-1">Andharam</th> 
        </tr>
      </thead>
      <tbody class="m-0 p-0">
        <tr class="m-0 p-0"  onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent text-start">Planet</th>
          <td class="m-0 p-1 bg-transparent">{clientData.currentDashaName}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentBhuktiName}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentAndharamName}</td>
        </tr>  
        <tr class="m-0 p-0"  onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent text-start">Start Date</th>
          <td class="m-0 p-1 bg-transparent">{clientData.currentDashaStart.substring(0,10)}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentBhuktiStart.substring(0,10)}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentAndharamStart.substring(0,10)}</td>
        </tr>  
        <tr class="m-0 p-0"  onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent text-start">End Date</th>
          <td class="m-0 p-1 bg-transparent">{clientData.currentDashaEnd.substring(0,10)}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentBhuktiEnd.substring(0,10)}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentAndharamEnd.substring(0,10)}</td>
        </tr>  
        <tr class="m-0 p-0"  onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent text-start">Period</th>
          <td class="m-0 p-1 bg-transparent">{clientData.currentDashaPeriod}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentBhuktiPeriod}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentAndharamPeriod}</td>
        </tr>  
        <tr class="m-0 p-0"  onClick={handleClickColor}>
          <th class="m-0 p-1 bg-transparent text-start">Balance</th>
          <td class="m-0 p-1 bg-transparent">{clientData.currentDashaBalance}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentBhuktiBalance}</td>
          <td class="m-0 p-1 bg-transparent">{clientData.currentAndharamBalance}</td>
        </tr>
      </tbody>  
    </table>
  );
}